var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MagicStar() {
    return (_jsxs("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M11.0362 13.1306L12.5002 18.3333L13.9641 13.1306L19.1668 11.6667L13.9641 10.2027L12.5002 5L11.0362 10.2027L5.8335 11.6667L11.0362 13.1306Z", fill: "#192121" }), _jsx("path", { d: "M3.94271 6.05713L4.58317 8.33333L5.22364 6.05713L7.49984 5.41667L5.22364 4.7762L4.58317 2.5L3.94271 4.7762L1.6665 5.41667L3.94271 6.05713Z", fill: "#192121" })] })));
}
